"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ComputerRam: ['computer-ram', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.667,7.4a.5.5,0,0,0,0-.707L17.3.334a.5.5,0,0,0-.707,0l-1.04,1.04a.25.25,0,0,0,0,.353l1.238,1.238a.5.5,0,1,1-.707.707L14.848,2.435a.249.249,0,0,0-.353,0l-.707.707a.249.249,0,0,0,0,.353l1.237,1.237a.5.5,0,0,1-.707.707L13.081,4.2a.252.252,0,0,0-.354,0l-.883.884L13.257,6.5a.5.5,0,1,1-.707.707L11.313,5.97a.25.25,0,0,0-.353,0L9.525,7.405a.5.5,0,0,0,0,.708l.353.352A1,1,0,0,1,8.465,9.88l-.354-.354a.5.5,0,0,0-.707,0L6.01,10.92a.251.251,0,0,0,0,.354L7.247,12.51a.5.5,0,0,1-.707.707L5.3,11.981a.25.25,0,0,0-.354,0l-.707.707a.25.25,0,0,0,0,.354l1.237,1.237a.5.5,0,1,1-.707.707L3.535,13.749a.251.251,0,0,0-.354,0l-.707.707a.25.25,0,0,0,0,.353l1.238,1.238a.5.5,0,1,1-.707.707L1.767,15.516a.25.25,0,0,0-.353,0L.333,16.6a.5.5,0,0,0,0,.707L6.7,23.668a.5.5,0,0,0,.707,0Zm-6.01-1.768a1,1,0,0,1,1.414,0l.707.707a1,1,0,0,1,0,1.415L17.656,9.88a1,1,0,0,1-1.414,0l-.707-.707a1,1,0,0,1,0-1.415Zm-4.95,4.951a1,1,0,0,1,1.414,0l.707.707a1,1,0,0,1,0,1.414l-2.121,2.121a1,1,0,0,1-1.414,0l-.707-.707a1,1,0,0,1,0-1.414ZM5.636,17.658l2.121-2.122a1,1,0,0,1,1.415,0l.707.708a1,1,0,0,1,0,1.414L7.758,19.779a1,1,0,0,1-1.414,0l-.708-.707A1,1,0,0,1,5.636,17.658Z']],
  SdCard: ['sd-card', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.561,4.854,16.146.44A1.511,1.511,0,0,0,15.086,0H4.5A1.5,1.5,0,0,0,3,1.5v7a.5.5,0,0,0,.5.5H4.75a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H3.5a.5.5,0,0,0-.5.5v10A1.5,1.5,0,0,0,4.5,24h15A1.5,1.5,0,0,0,21,22.5V5.915A1.511,1.511,0,0,0,20.561,4.854ZM17.75,5.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0ZM9.584,20.223l2-3a.52.52,0,0,1,.832,0l2,3A.5.5,0,0,1,14,21H10a.5.5,0,0,1-.416-.778ZM9,9.251a.75.75,0,0,1-.75-.75v-5a.75.75,0,1,1,1.5,0v5A.75.75,0,0,1,9,9.251Zm3.25-.75v-5a.75.75,0,0,1,1.5,0v5a.75.75,0,0,1-1.5,0Z']],
  FlashDrive: ['flash-drive', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11,3a.5.5,0,0,0-.5.5v1a.5.5,0,1,0,1,0v-1A.5.5,0,0,0,11,3Z', 'M13,3a.5.5,0,0,0-.5.5v1a.5.5,0,1,0,1,0v-1A.5.5,0,0,0,13,3Z', 'M16.643,6.652a.25.25,0,0,1-.143-.226V2a2,2,0,0,0-2-2h-5a2,2,0,0,0-2,2V6.426a.252.252,0,0,1-.143.226A1.5,1.5,0,0,0,6.5,8V19.5A4.505,4.505,0,0,0,11,24h2a4.505,4.505,0,0,0,4.5-4.5V8A1.5,1.5,0,0,0,16.643,6.652ZM13.5,11.5h-3a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm-4-9.25A.25.25,0,0,1,9.75,2h4.5a.25.25,0,0,1,.25.25v3.5a.25.25,0,0,1-.25.25H9.75a.25.25,0,0,1-.25-.25Z']],
  SdCardAdd: ['sd-card-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a8.01,8.01,0,0,1,6.3-7.814.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.511,1.511,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm.75,9a.75.75,0,1,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,1,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5H18.5a.25.25,0,0,0-.25.25Z']],
  SdCardQuestion: ['sd-card-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a8.01,8.01,0,0,1,6.3-7.814.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.511,1.511,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.625,4.875a2.638,2.638,0,0,1-1.875,2.515v.36a.75.75,0,1,1-1.5,0V18.2a1.258,1.258,0,0,1,.987-1.222,1.125,1.125,0,1,0-1.362-1.1.75.75,0,1,1-1.5,0,2.625,2.625,0,1,1,5.25,0ZM17.5,20.5a1,1,0,1,1-1,1A1,1,0,0,1,17.5,20.5Z']],
  SdCardRemove: ['sd-card-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a8.01,8.01,0,0,1,6.3-7.814.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.49,1.49,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-1.591,9.151a.75.75,0,0,1-1.06-1.061l1.414-1.414a.25.25,0,0,0,0-.353L14.849,15.91a.75.75,0,0,1,1.06-1.061l1.414,1.414a.25.25,0,0,0,.354,0l1.414-1.414a.75.75,0,1,1,1.06,1.061l-1.414,1.414a.25.25,0,0,0,0,.353l1.414,1.414a.75.75,0,1,1-1.06,1.061l-1.414-1.414a.25.25,0,0,0-.354,0Z']],
  SdCardRefresh: ['sd-card-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.011,17.5A8.006,8.006,0,0,1,15.8,9.6a.251.251,0,0,0,.213-.247V4.915a1.508,1.508,0,0,0-.44-1.061L12.157.44A1.49,1.49,0,0,0,11.1,0H1.511a1.5,1.5,0,0,0-1.5,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.511a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5H9.672a.251.251,0,0,0,.222-.365A7.912,7.912,0,0,1,9.011,17.5Zm-.75-14v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.136,11.251A6.375,6.375,0,1,0,22.118,21.6a1,1,0,0,0-1.562-1.248,4.375,4.375,0,1,1-.306-5.8l-1.571,1.572a.5.5,0,0,0,.353.853h4.457a.5.5,0,0,0,.5-.5V12.022a.5.5,0,0,0-.853-.353l-1.472,1.472A6.327,6.327,0,0,0,17.136,11.251Z']],
  SdCardDownload: ['sd-card-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a8.01,8.01,0,0,1,6.3-7.814.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.511,1.511,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,24A6.5,6.5,0,1,0,11,17.5,6.508,6.508,0,0,0,17.5,24Zm-2.45-6.217a.5.5,0,0,1,.45-.283h1a.25.25,0,0,0,.25-.25V14.5a.75.75,0,1,1,1.5,0v2.75a.25.25,0,0,0,.25.25h1a.5.5,0,0,1,.391.812l-2,2.5a.519.519,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,15.05,17.784Z']],
  SdCardUpload: ['sd-card-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a8.01,8.01,0,0,1,6.3-7.814.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.511,1.511,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.45,6.216a.5.5,0,0,1-.45.284h-1a.25.25,0,0,0-.25.25V20.5a.75.75,0,1,1-1.5,0v-2.75a.25.25,0,0,0-.25-.25h-1a.5.5,0,0,1-.391-.813l2-2.5a.52.52,0,0,1,.782,0l2,2.5A.5.5,0,0,1,19.95,17.217Z']],
  SdCardSubtract: ['sd-card-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.8,9.687a.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.511,1.511,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5,8.01,8.01,0,0,1,15.8,9.687ZM10.25,3.5a.75.75,0,1,1,1.5,0v4a.75.75,0,1,1-1.5,0Zm-5.5,4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm3.5,0a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.5,7.25H15a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z']],
  SdCardWarning: ['sd-card-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.891,11.575a2.93,2.93,0,0,1,1-1.092.25.25,0,0,0,.114-.21V4.915a1.512,1.512,0,0,0-.44-1.061L12.147.44A1.491,1.491,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5H9.549a.25.25,0,0,0,.237-.171.791.791,0,0,1,.05-.121ZM8.251,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M18.782,12.272a1.451,1.451,0,0,0-2.563,0l-5.055,9.634a1.431,1.431,0,0,0,.048,1.408A1.456,1.456,0,0,0,12.445,24H22.556a1.459,1.459,0,0,0,1.234-.687,1.434,1.434,0,0,0,.047-1.408ZM17.5,15.251a.75.75,0,0,1,.75.75v3a.75.75,0,0,1-1.5,0V16A.75.75,0,0,1,17.5,15.251Zm0,7a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22.251Z']],
  SdCardDisable: ['sd-card-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.706,19.33a8.035,8.035,0,0,1,2.139-7.487A7.942,7.942,0,0,1,15.8,9.7a.25.25,0,0,0,.2-.244V4.916a1.511,1.511,0,0,0-.439-1.061L12.148.441A1.513,1.513,0,0,0,11.087,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.637a.251.251,0,0,0,.223-.363A7.721,7.721,0,0,1,9.706,19.33ZM8.251,3.5v4a.75.75,0,1,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm-3.5,0v4a.75.75,0,1,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm7,4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Z', 'M19,11.17A6.513,6.513,0,0,0,11.169,19,6.421,6.421,0,0,0,16,23.833a6.76,6.76,0,0,0,1.49.167,6.5,6.5,0,0,0,6.341-8A6.422,6.422,0,0,0,19,11.17ZM15.389,21.482a.25.25,0,0,1-.057-.4l5.753-5.753a.245.245,0,0,1,.212-.07.25.25,0,0,1,.184.127,4.508,4.508,0,0,1-6.092,6.093Zm4.224-7.96a.249.249,0,0,1,.057.4l-5.746,5.747a.25.25,0,0,1-.4-.066,4.441,4.441,0,0,1,.8-5.28A4.608,4.608,0,0,1,19.613,13.522Z']],
  SdCardCheck: ['sd-card-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.5a8.01,8.01,0,0,1,6.3-7.814.25.25,0,0,0,.2-.244V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.49,1.49,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5h8.661a.251.251,0,0,0,.222-.365A7.925,7.925,0,0,1,9.5,17.5ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-1.894,9.236-1.5-1.5a.75.75,0,0,1,1.061-1.061l1.5,1.5,2.905-3.874a.75.75,0,0,1,1.2.9L17.869,20.08A1.5,1.5,0,0,1,15.606,20.237Z']],
  ComputerRam1: ['computer-ram-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.667,7.4a.5.5,0,0,0,0-.707L17.3.334a.5.5,0,0,0-.707,0l-1.04,1.04a.249.249,0,0,0,0,.353l1.237,1.238a.5.5,0,1,1-.707.707L14.849,2.434a.251.251,0,0,0-.354,0l-.707.708a.25.25,0,0,0,0,.353l1.237,1.237a.5.5,0,0,1-.707.707L13.081,4.2a.25.25,0,0,0-.353,0l-.707.707a.25.25,0,0,0,0,.354L13.258,6.5a.5.5,0,0,1-.707.707L11.314,5.97a.251.251,0,0,0-.354,0L9.525,7.405a.5.5,0,0,0,0,.708l.354.352a1,1,0,0,1,0,1.415,1.025,1.025,0,0,1-1.414,0l-.354-.354a.5.5,0,0,0-.707,0L6.01,10.92a.251.251,0,0,0,0,.354L7.248,12.51a.5.5,0,1,1-.707.707L5.3,11.981a.249.249,0,0,0-.353,0l-.707.707a.249.249,0,0,0,0,.353l1.236,1.238a.5.5,0,1,1-.707.707L3.536,13.748a.251.251,0,0,0-.354,0l-.707.708a.249.249,0,0,0,0,.353l1.237,1.238a.5.5,0,1,1-.707.707L1.768,15.516a.252.252,0,0,0-.354,0L.333,16.6a.5.5,0,0,0,0,.707L6.7,23.668a.5.5,0,0,0,.707,0Zm-6.01-1.768a1,1,0,0,1,1.414,0l.707.707a1,1,0,0,1,0,1.414L17.656,9.879a1,1,0,0,1-1.414,0l-.707-.707a1,1,0,0,1,0-1.414ZM5.636,17.657l2.122-2.121a1,1,0,0,1,1.414,0l.707.707a1,1,0,0,1,0,1.415L7.758,19.779a1,1,0,0,1-1.414,0l-.708-.707A1,1,0,0,1,5.636,17.657Z']],
  FlashDriveLock: ['flash-drive-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,22.5V17a3,3,0,0,1,1.385-2.528.251.251,0,0,0,.115-.21v-.512a4.8,4.8,0,0,1,3.765-4.33.249.249,0,0,0,.177-.306A1.494,1.494,0,0,0,15.5,8a.25.25,0,0,1-.25-.25v-6A1.752,1.752,0,0,0,13.5,0h-9a1.752,1.752,0,0,0-1.75,1.75v6A.25.25,0,0,1,2.5,8,1.5,1.5,0,0,0,1,9.5v12A2.5,2.5,0,0,0,3.5,24h8.011a.251.251,0,0,0,.23-.349A2.906,2.906,0,0,1,11.5,22.5ZM4.25,1.751A.25.25,0,0,1,4.5,1.5h9a.25.25,0,0,1,.25.25v6A.25.25,0,0,1,13.5,8h-9a.25.25,0,0,1-.25-.25Z', 'M6.000 3.501 L8.000 3.501 L8.000 5.501 L6.000 5.501 Z', 'M10.000 3.501 L12.000 3.501 L12.000 5.501 L10.000 5.501 Z', 'M21.714,15.516a.25.25,0,0,1-.214-.248V14.251a3.5,3.5,0,1,0-7,0v1.017a.25.25,0,0,1-.214.248A1.5,1.5,0,0,0,13,17v5.5A1.5,1.5,0,0,0,14.5,24h7A1.5,1.5,0,0,0,23,22.5V17A1.5,1.5,0,0,0,21.714,15.516ZM18,12.751a1.5,1.5,0,0,1,1.5,1.5v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1A1.5,1.5,0,0,1,18,12.751Zm1,7.5a1,1,0,1,1-1-1A1,1,0,0,1,19,20.251Z']],
  SdCardSettings: ['sd-card-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.881,17.358l.174-.187a.25.25,0,0,0,0-.34l-.175-.189a3.282,3.282,0,0,1,3.139-5.433l.229.053a.25.25,0,0,0,.295-.171l.071-.234A3.256,3.256,0,0,1,15.89,9.118.251.251,0,0,0,16,8.912V4.946a1.514,1.514,0,0,0-.44-1.061L12.145.471a1.49,1.49,0,0,0-1.06-.439H1.5A1.5,1.5,0,0,0,0,1.532v7.5a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5v7.5a1.5,1.5,0,0,0,1.5,1.5h8.78a.194.194,0,0,0,.167-.29A3.271,3.271,0,0,1,10.881,17.358ZM8.249,3.532v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Zm7,4a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0Z', 'M16.248 17.001 A1.500 1.500 0 1 0 19.248 17.001 A1.500 1.500 0 1 0 16.248 17.001 Z', 'M23.516,15.623a1.783,1.783,0,0,0-1.7-2.953L20.4,13a.448.448,0,0,1-.532-.311L19.448,11.3a1.775,1.775,0,0,0-3.4,0l-.424,1.391a.455.455,0,0,1-.533.311l-1.411-.327a1.783,1.783,0,0,0-1.7,2.953l.988,1.065a.463.463,0,0,1,0,.625l-.988,1.066a1.783,1.783,0,0,0,1.7,2.953l1.411-.327a.455.455,0,0,1,.533.31l.424,1.392a1.775,1.775,0,0,0,3.4,0l.424-1.392a.447.447,0,0,1,.533-.31l1.411.327a1.783,1.783,0,0,0,1.7-2.953l-.987-1.066a.463.463,0,0,1,0-.625ZM17.748,20a3,3,0,1,1,3-3A3,3,0,0,1,17.748,20Z']],
  SdCardSync: ['sd-card-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,17.751a8.227,8.227,0,0,1,6.3-8.006A.25.25,0,0,0,16,9.5V4.915a1.511,1.511,0,0,0-.439-1.061L12.146.44A1.49,1.49,0,0,0,11.086,0H1.5A1.5,1.5,0,0,0,0,1.5V9a.5.5,0,0,0,.5.5h.75a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5V20a1.5,1.5,0,0,0,1.5,1.5H9.25a.25.25,0,0,0,.25-.25ZM8.25,3.5v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm-3.5,0v4a.75.75,0,0,1-1.5,0v-4a.75.75,0,1,1,1.5,0Zm7,4a.75.75,0,1,1-1.5,0v-4a.75.75,0,1,1,1.5,0Z', 'M12.823,22.064a.251.251,0,0,1,.359,0,6.085,6.085,0,0,0,10.21-2.2,1,1,0,0,0-1.893-.649,4.09,4.09,0,0,1-6.918,1.42.25.25,0,0,1,.008-.345l1.722-1.721a.5.5,0,0,0-.354-.854H11.5a.5.5,0,0,0-.5.5V22.68a.5.5,0,0,0,.309.462.539.539,0,0,0,.545-.108Z', 'M17.347,11a6.108,6.108,0,0,0-5.78,4.129,1,1,0,0,0,1.893.648,4.092,4.092,0,0,1,6.9-1.445.249.249,0,0,1-.007.346l-1.66,1.659a.5.5,0,0,0,.354.854H23.5a.5.5,0,0,0,.5-.5V12.235a.5.5,0,0,0-.854-.353l-1.025,1.025a.251.251,0,0,1-.358,0A6.118,6.118,0,0,0,17.347,11Z']]
};
exports["default"] = _default;